import { CssBaseline, ThemeProvider } from '@mui/material';
import { useNavigate, useRoutes } from 'react-router-dom';
import Router from './routes/Router';
import './Global.css';
import { baselightTheme } from './theme/DefaultColors';
import MainState from './context/MainState';
import { useEffect } from 'react';
import { useMain } from './views/hooks/useMain';

function App() {
  const routing = useRoutes(Router);
  const theme = baselightTheme;

  const { setSuperAdminId, getSuperAdmin, setSuperAdminData } = useMain();
  const navigate = useNavigate();

  const getData = async (id) => {
    try {
      const res = await getSuperAdmin(id);
      if (res.statusCode === 200) {
        setSuperAdminData(res.data);
      } else {
        localStorage.removeItem('salon-superAdmin');
        navigate('/auth/login');
      }
    } catch (error) {
      localStorage.removeItem('salon-superAdmin');
      navigate('/auth/login');
    }
  };

  useEffect(() => {
    const id = JSON.parse(localStorage.getItem('salon-superAdmin'));
    if (id) {
      setSuperAdminId(id);
      getData(id);
    } else {
      navigate('/auth/login');
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {routing}
    </ThemeProvider>
  );
}

export default App;
